import { render, staticRenderFns } from "./SectionTickets.vue?vue&type=template&id=c9321a26&scoped=true&"
import script from "./SectionTickets.vue?vue&type=script&lang=js&"
export * from "./SectionTickets.vue?vue&type=script&lang=js&"
import style0 from "./SectionTickets.vue?vue&type=style&index=0&id=c9321a26&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9321a26",
  null
  
)

export default component.exports